import { Pin } from "lucide-react";
import { IconButton, cn } from "@nexus/ui";

import { usePinnedDashboards } from "@/hooks/dashboard/usePinnedDashboards";

/**
 * Pins a dashboard to the person's shortlist: the "Pinned" group of Workspace,
 * the top of the dashboard list and Home. Quiet until pinned, then filled in the
 * interaction colour so a pinned row is recognised at a glance.
 */
export function PinDashboardButton({
  dashboardId,
  name,
  size = "sm",
  className,
}: {
  dashboardId: string;
  name: string;
  size?: "sm" | "md";
  className?: string;
}) {
  const pins = usePinnedDashboards();
  if (!pins.available) return null;
  const pinned = pins.isPinned(dashboardId);
  const label = pinned ? `Unpin ${name}` : `Pin ${name}`;
  return (
    <IconButton
      label={label}
      title={pinned ? "Unpin" : "Pin to Workspace and Home"}
      size={size}
      aria-pressed={pinned}
      onClick={(event) => {
        event.stopPropagation();
        pins.toggle(dashboardId);
      }}
      onKeyDown={(event) => event.stopPropagation()}
      className={cn(
        pinned ? "text-interaction-text hover:text-interaction-text" : "text-muted",
        className,
      )}
    >
      <Pin className={cn("size-4", pinned && "fill-current")} aria-hidden />
    </IconButton>
  );
}
